export const randomSeed = () => Math.floor(Math.random() * 2147483646);
